/* src/app/forms/produtos/amazon/amazon-search-category/amazon-search-category.component.scss */
.tree-view-container {
  display: flex;
  flex-direction: column;
}
.tree-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}
.collapse-icon {
  cursor: pointer;
  margin-right: 8px;
  transition: transform 0.3s ease;
}
.collapse-icon.collapsed {
  transform: rotate(-90deg);
}
.item-content {
  flex: 1;
}
.view-component-title {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px 20px;
  background: rgba(0, 0, 0, 0.03);
  font-size: 100%;
}
.pointer-menu {
  cursor: pointer;
}
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 80%;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow: auto;
  padding: 15px;
}
.tree-item.selected {
  background-color: #e3e3e3;
}
/*# sourceMappingURL=amazon-search-category.component.css.map */
